import { getToken } from "helper/common";
import {
    CLEAR_REGION_LIST,
    SET_REGION_LIST,
    REGION_CREATE_DIALOG_CLOSE,
    REGION_CREATE_DIALOG_OPEN,
    REGION_CREATE_ERROR,
    REGION_CREATE_ERROR_CLEAR,
    REGION_CREATE_PENDING,
    REGION_EDIT_DIALOG_CLOSE,
    REGION_EDIT_DIALOG_OPEN,
    REGION_EDIT_ERROR,
    REGION_EDIT_ERROR_CLEAR,
    REGION_EDIT_PENDING,
    REGION_LIST_ERROR,
    REGION_LIST_ERROR_CLEAR,
    REGION_LIST_PENDING,
    REGION_FILTER_DIALOG_OPEN,
    REGION_FILTER_DIALOG_CLOSE,
    SET_REGION_FILTER_DATA,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setRegionList = (regionList) => ({
    type: SET_REGION_LIST,
    payload: { regionList }
});

export const clearRegionList = () => ({
    type: CLEAR_REGION_LIST,
});

export const regionListPending = () => ({
    type: REGION_LIST_PENDING
});

export const regionListError = (errorMessage) => ({
    type: REGION_LIST_ERROR,
    payload: { errorMessage }
});

export const regionListErrorClear = () => ({
    type: REGION_LIST_ERROR_CLEAR
});

export const getRegionList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(regionListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.regionConfiguration.getRegionList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((regionList) => {
                dispatch(setRegionList(regionList));
                dispatch(regionListErrorClear());
                dispatch(regionEditErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(regionListError(message));
                }
                else {
                    dispatch(regionListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openRegionFilterDialog = () => ({
    type: REGION_FILTER_DIALOG_OPEN
});

export const closeRegionFilterDialog = () => ({
    type: REGION_FILTER_DIALOG_CLOSE
});

export const setRegionFilteredData = (filter) => ({
    type: SET_REGION_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openRegionCreateDialog = () => ({
    type: REGION_CREATE_DIALOG_OPEN
});

export const closeRegionCreateDialog = () => ({
    type: REGION_CREATE_DIALOG_CLOSE
});

export const regionCreatePending = () => ({
    type: REGION_CREATE_PENDING
});

export const regionCreateError = (errorMessage) => ({
    type: REGION_CREATE_ERROR,
    payload: { errorMessage }
});

export const regionCreateErrorClear = () => ({
    type: REGION_CREATE_ERROR_CLEAR
});

export const regionCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(regionCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.regionConfiguration.regionCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getRegionList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(regionCreateErrorClear());
                dispatch(closeRegionCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Region successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(regionCreateError(message));
                }
                else {
                    dispatch(regionCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openRegionEditDialog = () => ({
    type: REGION_EDIT_DIALOG_OPEN
});

export const closeRegionEditDialog = () => ({
    type: REGION_EDIT_DIALOG_CLOSE
});

export const regionEditPending = () => ({
    type: REGION_EDIT_PENDING
});

export const regionEditError = (errorMessage) => ({
    type: REGION_EDIT_ERROR,
    payload: { errorMessage }
});

export const regionEditErrorClear = () => ({
    type: REGION_EDIT_ERROR_CLEAR
});

export const regionEdit = (formData, page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(regionEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.regionConfiguration.regionEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getRegionList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(regionEditErrorClear());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Region details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.resolve(true);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(regionEditError(message));
                }
                else {
                    dispatch(regionEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
